import { ScrollArea } from "@/components/ui/scroll-area";
import PrivacyHeader from "@/components/privacy/PrivacyHeader";
import PrivacyIntroduction from "@/components/privacy/PrivacyIntroduction";
import ThirdPartyCookies from "@/components/privacy/ThirdPartyCookies";
import CookieConsent from "@/components/privacy/CookieConsent";
import DataCollection from "@/components/privacy/DataCollection";
import AIVoiceProcessing from "@/components/privacy/AIVoiceProcessing";
import AutomaticInformation from "@/components/privacy/AutomaticInformation";
import DataProtection from "@/components/privacy/DataProtection";
import DataRetention from "@/components/privacy/DataRetention";
import YourRights from "@/components/privacy/YourRights";
import LegalInformation from "@/components/privacy/LegalInformation";
import ContactInformation from "@/components/privacy/ContactInformation";

const Privacy = () => {
  return (
    <div>
      <main>
        <ScrollArea className="h-screen">
          <div className="max-w-3xl mx-auto prose prose-sm sm:prose prose-slate dark:prose-invert px-4 py-8">
            <PrivacyHeader />
            <PrivacyIntroduction />
            
            <p className="mb-6">
              This Privacy Policy ("Privacy Policy") describes how WhooShare BV. will gather, use, and maintain your Personal Information on the Vtranslate. It will also explain your legal rights with respect to that information.
            </p>

            <p className="mb-6">
              By using the WhooShare BV App or services, you confirm that you have read and understand this Privacy Policy, and our <a href="/terms-and-conditions" className="text-blue-600 hover:underline">Terms</a> (together referred to herein as the "Agreement"). The Agreement governs the use of Vtranslate. WhooShare BV will collect, use, and maintain information consistent with the Agreement.
            </p>

            <p className="mb-6">
              The app does use third party services that may collect information used to identify you.
            </p>

            <p className="mb-6">
              Link to privacy policy of third-party service providers used by the app:
            </p>
            <ul className="list-disc pl-6 mb-8">
              <li className="mb-2">
                <a href="https://policies.google.com/privacy" className="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer">Google Play Services</a>
              </li>
              <li className="mb-2">
                <a href="https://www.apple.com/legal/privacy/" className="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer">Apple iOS</a>
              </li>
              <li className="mb-2">
                <a href="https://openai.com/policies/privacy-policy" className="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer">OpenAI</a>
              </li>
              <li className="mb-2">
                <a href="https://soniox.com/privacy" className="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer">Soniox</a>
              </li>
              <li className="mb-2">
                <a href="https://cloud.google.com/terms/cloud-privacy-notice" className="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer">Google Cloud</a>
              </li>
              <li className="mb-2">
                <a href="https://privacy.microsoft.com/en-us/privacystatement" className="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer">Microsoft Azure</a>
              </li>
            </ul>

            <DataCollection />
            <AIVoiceProcessing />
            <AutomaticInformation />
            <ThirdPartyCookies />
            <CookieConsent />
            <DataProtection />
            <DataRetention />
            <YourRights />
            <LegalInformation />
            <ContactInformation />
          </div>
        </ScrollArea>
      </main>
    </div>
  );
};

export default Privacy;